@let isReadonly = isReadonly$ | async;

@if(!isReadonly) {
<rask-button [disabled]="aterstallDisabled"
    (click)="onAterstall()"
    class="p-0"
    color="secondary">
    Återställ
</rask-button>
}

@if (utskrift()) {
<form class="utskrift-form" [formGroup]="form">
    @if (kontrakt.isAffarsformU4) {
    <div class="row mt-2">
        <rask-input class="col-6 mt-0" label="Drivningskostnader, kr/m3f"
            [inputProcessor]="seIntProcessor"
            formControlName="drivningskostnad">
        </rask-input>
    </div>
    }
    @if (showKontraktGruppering) {
    <div class="row mt-3 kontraktgruppering">
        <rask-kontrakt-gruppering class="col-6"
            [formGroup]="form">
        </rask-kontrakt-gruppering>
    </div>
    }
    @if (showVolymOchBelopp) {
    <div>
        <rask-header size="4">Preliminär volym och belopp</rask-header>
        <rask-kontrakt-volym-belopp
            [formGroup]="form">
        </rask-kontrakt-volym-belopp>
    </div>
    }
    @if (showPristabell) {
    <div>
        <rask-header size="4">Pristabell</rask-header>
        <rask-kontrakt-pristabell [form]="form">
        </rask-kontrakt-pristabell>
    </div>
    }
    @if (kontrakt.isLeveransvirke) {
    <rask-checkbox class="mt-6 p-0 d-block"
        text="Visa leveransvirkesplan på utskrift"
        formControlName="leveransvirkesplanIUtskrift">
    </rask-checkbox>
    }
    @if (kontrakt.isRotpost) {
    <rask-header size="4" class="p-0 m-0">Stämplingslängd</rask-header>
    <div class="row">
        <rask-datepicker class="col-8 mt-0" label="Datum uprättad*"
            formControlName="stamplingsLangdUpprattatDatum">
        </rask-datepicker>
        <rask-input class="col-4 mt-0" label="Antal träd, st*"
            [inputProcessor]="seIntProcessor"
            formControlName="stamplingsLangdAntalTrad">
        </rask-input>
    </div>
    <rask-textarea class="w-100 p-0 textarea-margin" label="Upprättad av*"
        formControlName="stamplingsLangdUpprattatAv"
        [maxlength]="100">
    </rask-textarea>
    <rask-header size="4" class="p-0 m-0">Köpeskilling</rask-header>
    <div class="row textarea-margin">
        <rask-input class="col-4 mt-0" label="Exkl. moms, kr*"
            [inputProcessor]="seIntProcessor"
            formControlName="kontraktsbelopp">
        </rask-input>
        @if (!kontrakt.isRotpost) {
        <rask-input class="col-8 mt-0" label="Exkl. moms utskrivet, kr*"
            [maxlength]="50"
            formControlName="kontraktsbeloppUtskrivet">
        </rask-input>
        }
    </div>
    }
    <div class="w-100 mb-3">
        <rask-textarea class="w-100 p-0" label="Övrigt överenskommet mellan köpare och säljare"
            formControlName="ovrigtOverenskommet"
            [maxlength]="500">
        </rask-textarea>
    </div>
    <div class="w-100 mb-3">
        @if (showMakeGodkannandeKravsEj) {
        <rask-multi-selector
            class="p-0"
            label="Godkännande av äkta make/maka krävs ej för valda leverantörer nedan"
            [items]="leverantorItems$"
            bindLabel="namn"
            bindValue="guid"
            [raskDisabledControl]="isReadonly"
            [searchFn]="leverantorSearchFn"
            [formControl]="selectedLeverantorer">
        </rask-multi-selector>
        }
    </div>
</form>
}